import { RECOMMEND_EVENT_TYPE } from '../../../../constants/service/app/recommendEventConstants';
import { _LIST_PAGINATION_MODEL } from '../../app/models';

/**
 *  추천 기획전 리스트 검색 박스 모델
 */
export const RECOMMEND_EVENT_LIST_SEARCH_DATA_MODEL = {
  /**
   *  추천 기획전 타입
   */
  recommendEventType: RECOMMEND_EVENT_TYPE.SEARCH_RECOMMEND,
  /**
   *  추천인
   */
  adminName: null,
  /**
   *  메모
   */
  memo: null,
  /**
   *  추천 기획전 생성일
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  추천 기획전 리스트 검색 옵션 모델
 */
export const RECOMMEND_EVENT_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  추천 기획전 타입
   */
  recommendEventType: RECOMMEND_EVENT_TYPE.SEARCH_RECOMMEND,
  /**
   *  추천인
   */
  adminName: null,
  /**
   *  메모
   */
  memo: null,
  /**
   *  추천 기획전 생성일
   */
  createDate: null,
};

/**
 *  추천 기획전에 연결할 아이템 리스트 필터 옵션 모델
 */
export const RECOMMEND_EVENT_ITEM_LIST_FILTER_OPTION_MODEL = {
  /**
   *  기획전 번호
   */
  eventId: null,
  /**
   *  제목
   */
  mainTitle: null,
};

/**
 *  추천 기획전 등록/복사
 */
export const RECOMMEND_EVENT_SAVE_MODEL = {
  /**
   *  추천 기획전 정보
   */
  recommendEventInfo: {
    /**
     *  추천 기획전 타입
     */
    type: RECOMMEND_EVENT_TYPE.SEARCH_RECOMMEND,
    /**
     *  메모
     */
    memo: null,
  },
  /**
   *  추천 기획전 아이템 리스트
   */
  recommendEventItemList: {
    /**
     *  추천 기획전에 연결할 아이템 리스트
     */
    itemList: {
      /**
       * 리스트
       */
      list: [],
      /**
       *  필터 옵션
       */
      filterOption: RECOMMEND_EVENT_ITEM_LIST_FILTER_OPTION_MODEL,
      /**
       * pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    },
    /**
     *  선택된 추천 기획전에 연결된 아이템 리스트
     */
    selectedItemList: {
      list: [],
      idList: [],
    },
  },
};
